import React, { useState } from 'react';
import {
  Row,
  Col,
  Divider,
  Input,
  Typography,
  Table,
  Space,
  Tag,
  Statistic,
  Skeleton,
  Result
} from 'antd'
import {
  SearchOutlined
} from '@ant-design/icons';
import DeletePopupButton from './components/DeletePopupButton';
import EditFormModal from './components/EditFormModal';
import AddFormModal from './components/AddFormModal';
import { useQuery } from '@tanstack/react-query';
import AdjustStock from './components/AdjustStock';

const columns = ({ categories, brands }) => [
  {
    title: 'รุ่น',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'ประเภท',
    dataIndex: 'category',
    key: 'category',
    render: (_, record) => record?.category?.name ?? "_",
    filters: categories.map(f => ({ text: f.name, value: f.name })),
    onFilter: (value, record) => record?.category?.name.indexOf(value) === 0,
    sorter: (a, b) => a?.category?.name.localeCompare(b?.category?.name),
  },
  {
    title: 'แบรนด์',
    dataIndex: 'brand',
    key: 'brand',
    render: (_, record) => record?.brand?.name ?? "_",
    filters: brands.map(f => ({ text: f.name, value: f.name })),
    onFilter: (value, record) => record?.brand?.name.indexOf(value) === 0,
    sorter: (a, b) => a?.brand?.name.localeCompare(b?.brand?.name),
  },
  {
    title: 'สี',
    dataIndex: 'color',
    key: 'color',
  },
  {
    title: 'ราคาขายต่ำสุด',
    dataIndex: 'min_price',
    key: 'min_price',
    render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
  },
  {
    title: 'ราคาปกติ',
    dataIndex: 'price',
    key: 'price',
    render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
  },
  {
    title: 'ราคาขาย',
    dataIndex: 'selling_price',
    key: 'selling_price',
    render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
  },
  {
    title: 'มูลค่าต่อหน่วย',
    dataIndex: 'average_price',
    key: 'average_price',
    render: text => <Statistic value={text} precision={2} valueStyle={{ fontSize: 14 }} />
  },
  {
    title: 'จำนวนคงเหลือ',
    dataIndex: 'stock',
    key: 'stock',
  },
  {
    title: 'สถานะ',
    dataIndex: 'is_active',
    key: 'is_active',
    render: (_, record) => record.is_active ? <Tag color="green">ขาย</Tag> : <Tag color="red">ยกเลิก</Tag>
  },
  {
    title: '',
    dataIndex: 'action',
    key: 'action',
    render: (_, record) => (
      <Space size="middle">
        <EditFormModal data={record} categories={categories} brands={brands} />
        <AdjustStock data={record} />
        <DeletePopupButton data={record} />
      </Space>
    ),

  }
]

function List() {
  const [filterData, setFilterData] = useState(null);
  const brandsQuery = useQuery({ queryKey: ['/api/brand/'] })
  const categoriesQuery = useQuery({ queryKey: ['/api/category/'] })
  const productsQuery = useQuery({ queryKey: ['/api/product/'] })


  if (brandsQuery.isLoading || categoriesQuery.isLoading || productsQuery.isLoading) {
    return <Skeleton active />
  }

  if (brandsQuery.isError || categoriesQuery.isError || productsQuery.isError) {
    return <Result status="error" title={brandsQuery.error.message || categoriesQuery.error.message || productsQuery.error.message} />
  };

  const onSearch = e => {
    const s = e.target.value;
    const target = productsQuery.data.filter(f => f.name.includes(s) || f.category.name.includes(s) || f.brand.name.includes(s))
    // const target = productsQuery.data.filter(f => f.name.includes(s))
    setFilterData(target);
  }


  // console.log('brandsQuery.data :', brandsQuery.data);
  // console.log('categoriesQuery.data :', categoriesQuery.data);
  // console.log('productsQuery.data :', productsQuery.data);
  return (
    <div style={{
      background: '#fff',
    }}>

      <Row justify='space-between' >
        <Col xs={24} md={12} >
          <Typography.Title level={3}>
            รายการสินค้า
          </Typography.Title>
        </Col>
        <Col xs={24}>
          <Row justify="end">
            <Col>
              <AddFormModal categories={categoriesQuery.data} brands={brandsQuery.data} />
            </Col>
          </Row>
        </Col>
        <Divider />
        <Col xs={24} >
          <Row justify='space-between' gutter={[0, 16]}>
            <Col xs={24} sm={12} lg={8}>
              <Input placeholder="ค้นหา" prefix={<SearchOutlined />} onChange={onSearch} />
            </Col>
            <Col xs={24}>
              <Table
                rowKey={(record) => record._id}
                columns={columns({ categories: categoriesQuery.data, brands: brandsQuery.data })}
                dataSource={filterData || productsQuery.data}
                scroll={{
                  x: 1200,
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default List